import { ProgramService } from '@modules/program/program-service';
import Errors from '@shared/error/errors';
import { routerAsync } from '@/app-module';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import ManageModel from '@shared/manage/manage-model';

export default {
  namespaced: true,

  state: {
    findLoading: false,
    saveLoading: false,
    record: null,
  },

  getters: {
    record: (state) => state.record,
    findLoading: (state) => !!state.findLoading,
    saveLoading: (state) => !!state.saveLoading,
  },

  mutations: {
    RESET(state) {
      state.findLoading = false;
      state.saveLoading = false;
      state.record = null;
    },

    FIND_STARTED(state) {
      state.record = null;
      state.findLoading = true;
    },

    FIND_SUCCESS(state, payload) {
      state.record = payload;
      state.findLoading = false;
    },

    FIND_ERROR(state) {
      state.record = null;
      state.findLoading = false;
    },

    CREATE_STARTED(state) {
      state.saveLoading = true;
    },

    CREATE_SUCCESS(state) {
      state.saveLoading = false;
    },

    CREATE_ERROR(state) {
      state.saveLoading = false;
    },

    UPDATE_STARTED(state) {
      state.saveLoading = true;
    },

    UPDATE_SUCCESS(state) {
      state.saveLoading = false;
    },

    UPDATE_ERROR(state) {
      state.saveLoading = false;
    },
  },

  actions: {
    doNew({ commit }) {
      commit('RESET');
    },

    async doFind({ commit }, {id, manage}) {
      try {
        commit('FIND_STARTED');

        const manageInput = new ManageModel(manage).getManageModel()
        const record = await ProgramService.find(id, manageInput);

        commit('FIND_SUCCESS', record);
      } catch (error) {
        Errors.handle(error);
        commit('FIND_ERROR');
        routerAsync().push( { name: 'programList', params: {manage}});
      }
    },

    async doCreate({ commit }, {values, manage}) {
      try {
        commit('CREATE_STARTED');

        const manageInput = new ManageModel(manage).getManageModel()
        await ProgramService.create(values, manageInput);

        commit('CREATE_SUCCESS');
        routerAsync().push( { name: 'programList', params: {manage, type: values.type }});
        Message.success(i18n('entities.program.create.success'));
      } catch (error) {
        Errors.handle(error);
        commit('CREATE_ERROR');
      }
    },

    async doUpdate({ commit }, { id, values, manage }) {
      try {
        commit('UPDATE_STARTED');
        const manageInput = new ManageModel(manage).getManageModel()
        await ProgramService.update(id, values, manageInput);
        routerAsync().push( { name: 'programList', params: {manage, type: values.type}});
        commit('UPDATE_SUCCESS');
        Message.success(i18n('entities.program.update.success'));
      } catch (error) {
        Errors.handle(error);
        commit('UPDATE_ERROR');
      }
    }
  },
};
